/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryItemEditViewArchiveController(
    this: JS5Object,
    EnumService: JS5Object
) {
    this.$onInit = () => {
        this.availableSourceEndpoints = _.filter(this.deliveryEndpointsForPartner, {type: 'Network'});
        EnumService.queryForEnums().then(() => {
            this.availableFormats = EnumService.getEnumPicklist('ArchiveDeliveryItem_archiveFormat');
        })
    };
}

angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewArchive', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/archive/delivery-items-edit-view-archive-template.html',
    controller: DeliveryItemEditViewArchiveController,
    bindings: {
        editData: '<',
        deliveryEndpointsForPartner: '<'
    }
});
